import { ButtonLink } from "@/components/Buttons/index";

export default function DetailButton({ href }) {
  return (
    <ButtonLink borderLight medium fillTransparentGray fontBold href={href}>
      詳細を見る
    </ButtonLink>
  );
}
